import styled from 'styled-components'

export const GenericButtonsListWrapper = styled.div`
  .ant-btn {
    width: 2rem;
    height: 2rem;
  }
  
  .ant-btn svg {
    width: 6px;
    height: 19px;
    transform: translateX(-2px) translateY(-3px);
  }
`